import { render, staticRenderFns } from "./food.vue?vue&type=template&id=19703504&scoped=true&"
import script from "./food.vue?vue&type=script&lang=js&"
export * from "./food.vue?vue&type=script&lang=js&"
import style0 from "./food.vue?vue&type=style&index=0&id=19703504&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19703504",
  null
  
)

export default component.exports